import { useTranslation } from "react-i18next";
import { useEffect, useState, useContext, useCallback } from "react";
import _, { concat, sum } from "lodash";
import axios from "axios";
import { Price } from "../../components/__simple/_price";
import config from '../../configuration/config.json'
import { slugCombine, slugSplitter } from '../../utils/slugManager';
import { useParams, useRouteMatch } from "react-router-dom";
import { groupBy, includes, mapValues, omit } from "lodash";
import Skeleton from 'react-loading-skeleton';

const SaleAgreement = ({ slug,
    brand,
    image,
    title,
    description,
    subTitle,
    count,
    oldPrice,
    price
    , salesOrder
    , orderCustInfo
    , orderAuthorized
    , orderTrans


}) => {
    const { t: trans, i18n } = useTranslation(["mobileCommon", "mobileHeading", "messages", "new", "error", "info"]);
    let lang = i18n.language;

    const { number } = useParams();
    const [showPanel, setShowPanel] = useState(false);
    const [indexPanel, setIndexPanel] = useState("-1");


    const showPanelInfo = (currentIndexPanel) => {

        if (currentIndexPanel != indexPanel) {

            setIndexPanel(currentIndexPanel);
            setShowPanel(true);
        } else {

            setIndexPanel(currentIndexPanel);
            setShowPanel(!showPanel);
        }
    }

    const [showPanelL2, setShowPanelL2] = useState(false);
    const [indexPanelL2, setIndexPanelL2] = useState("-1");


    const showPanelInfoL2 = (currentIndexPanel) => {

        if (currentIndexPanel != indexPanelL2) {

            setIndexPanelL2(currentIndexPanel);
            setShowPanelL2(true);
        } else {

            setIndexPanelL2(currentIndexPanel);
            setShowPanelL2(!showPanelL2);
        }
    }

    const [showPanelL3, setShowPanelL3] = useState(false);
    const [indexPanelL3, setIndexPanelL3] = useState("-1");


    const showPanelInfoL3 = (currentIndexPanel) => {

        if (currentIndexPanel != indexPanelL3) {

            setIndexPanelL3(currentIndexPanel);
            setShowPanelL3(true);
        } else {

            setIndexPanelL3(currentIndexPanel);
            setShowPanelL3(!showPanelL3);
        }
    }


    useEffect(() => {

        callback();
    }, []);



    const vehicleFeatures = [{

        title: trans("new:year"),
        fieldName: "Model"
    }, {
        title: trans("new:hourse"),
        fieldName: "horsePower"
    }
        , {
        title: trans("new:seats"),
        fieldName: "seatsNumber"
    },
        , {
        title: trans("new:cylinders"),
        fieldName: "cylinders"
    },
        , {
        title: trans("new:liter"),
        fieldName: "liter"
    },
    {
        title: trans("new:petrol"),
        fieldName: "petrol"
    }];
    const [vehicle, setVehicle] = useState(null);
    const [selectedModel, setSelectedModel] = useState({});
    const [specifications, setSpecifications] = useState([]);
    const [extraDetails, setExtraDetails] = useState([]);
    const [isLoadingVehicle, setIsLoadingVehicle] = useState(false);
    const callback = useCallback(async () => {
        setIsLoadingVehicle(false);
        // try {
        //     const response = await axios.request({
        //         baseURL: '/',
        //         url: lang + "/api/VehicleOverview/" + slugSplitter("تويوتا,Toyota") + "/" + slug+ "/overview",
        //         method: "get",
        //     });
        //     console.log("data:", response.data)
        //     // resetValues();
        //     setIsLoadingVehicle(false);
        //     if (response.data.vehicle) {
        //         setVehicle(response.data.vehicle);

        //         const firstItem = await getCarModels(response.data.models);
        //     }

        // } catch (error) {
        //     setIsLoadingVehicle(false);
        //     console.log(error);
        // }




        try {
            axios.request({
                url: config.controllerUrl + 'api/SaleAgreement/FetchInvProductsEquipments',
                data: { guid: slug }, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    const groupResult = mapValues(groupBy(response.data, 'ID'), fList => fList.map(items => omit(items, 'ID')));

                    var dataFinal = [];
                    Object.keys(groupResult)?.map((key, index) => {

                        var data = [];
                        var note = "";
                        groupResult[key].forEach((a, i) => {
                            if (lang == "ar") {
                                note = note + a.DescriptionAr + "\n" + a.NoteAr + "\n";
                                a.note = note;
                            } else {
                                note = note + a.DescriptionEn + "\n" + a.NoteEn + "\n";
                                a.note = note;
                            }

                            if (i == (groupResult[key].length - 1))
                                data = [...data, a];

                        })
                        dataFinal = [...dataFinal, ...data];

                    })
                    setExtraDetails(dataFinal);


                })
                .catch(function (error) {
                    console.log("error Fetch_InvProductsEquipments: ", error);
                    console.log(error);
                });
        } catch (error) {

            console.log("error: Fetch_InvProductsEquipments", error);
        }


    }, []);

    // to fetch the car models
    const getCarModels = async (allModels) => {
        if (allModels.length > 0) {
            let vehicleModel = allModels.filter((model) => {
                return model.type === vehicle?.type;
            })[0];
            if (vehicleModel) {

                setSelectedModel(vehicleModel);
            } else {

                setSelectedModel(allModels[0]);
                vehicleModel = allModels[0];
            }

            const splittedValues = vehicleModel?.note.split('\n');
            setSpecifications(splittedValues);
            // const unionValues = union(splittedValues,values);
            return vehicleModel;
        }
        return null;
    };


    const formatDateTime = useCallback((date) => {

        try {
            if (date) {
                let dateNow = new Date(date);

                var formatDate = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: true, minute: '2-digit' };
                if (lang.language === "en") {
                    return dateNow.toLocaleDateString('en-US', formatDate);

                } else {
                    return dateNow.toLocaleDateString('en-US', formatDate);
                    // return dateNow.toLocaleDateString('ar-US', formatDate);
                }

            } else {
                return date;

            }
        } catch (error) {
            console.log(error);
            return date;
        }
    }, []);
    return (

        <>
            <section className="cart  h-full">

                <div className="my-20">
                    {

                        <div className="flex flex-col  p-10 nice-container">
                            <div className="cart-item-container" style={{ height: '35rem' }}>
                                <div className="flex flex-row nice-gap-2rem nice-flex-basis-size-70">
                                    <div className="cart-item-container-img nice-flex-basis-size-40">
                                        <img src={image ? (image.includes("data:") ? "":"data:image/png;base64," )+ image : '/assets/images/default.png'} alt={title} />
                                    </div>
                                    <div className="flex flex-col nice-gap-2rem justify-center nice-flex-basis-size-60 nice-flex-space-between">
                                        <h4 className="text-30 font-bold mb-5">{brand}</h4>

                                        <span className="text-24 text-bold">{title + " " + (orderTrans?.Model ? orderTrans?.Model:"")} </span>
                                        <span className="text-24 text-line-clamp text-line-clamp-2 text-bold"> {description}</span>
                                        <span className="text-24 text-bold"> {subTitle}</span>
                                        <div className="flex flex-row nice-gap-1rem">
                                            <span className="text-30 text-bold text-capitalize">{trans("new:quantity")}:</span>

                                            <span className="text-30">{count}</span>
                                        </div>
                                    </div>
                                </div >
                                <div className="flex flex-col  nice-justifiy-end nice-gap-1rem ">

                                    {
                                        (oldPrice && oldPrice > 0) ?
                                            <div className="flex nice-align-item-center nice-gap-1rem">

                                                <span className="line-through text-30 text-bold text-gray">
                                                    <Price price={oldPrice} classNameCurrency={"line-through text-20 text-gray"} />
                                                </span>
                                                {/* <span className="line-through text-30 text-gray">{" ريال "} </span> */}
                                            </div>
                                            : null

                                    }
                                    <div className="flex nice-align-item-center nice-gap-1rem">
                                        <span className=" text-40 text-bold text-primary">
                                            {price && <Price price={price} classNameCurrency={"text-20 text-primary"} />}
                                        </span>
                                        {/* <span className="text-30 text-primary">{" ريال "} </span> */}
                                    </div>
                                </div>
                            </div >
                        </div >

                    }

                    {
                        salesOrder?.SalesOrderID ?

                            <>
                                <div className="nice-container flex flex-col nice-gap-1rem mt-10">
                                    <div className="flex flex-row nice-gap-1rem">

                                        <span className="text-30 text-bold text-nowrap text-capitalize">{trans("new:sales_order_number")}:</span>
                                        <span className="text-30 text-bold">{salesOrder?.SalesOrderID}</span>
                                    </div >
                                    <div className="flex flex-row nice-gap-1rem">
                                        <span className="text-30 text-nowrap text-capitalize">{trans("new:sales_type")}:</span>
                                        <span className="text-30 ">{lang == "ar" ? salesOrder?.CustPaymentTypeAr : salesOrder?.CustPaymentTypeEn}</span>
                                    </div>
                                    <div className="flex flex-row nice-gap-1rem">
                                        <span className="text-30 text-nowrap text-capitalize">{trans("new:date_time")}:</span>
                                        <span className="text-30 language-en">{formatDateTime(salesOrder?.SalesOrderDate)}</span>
                                    </div>
                                    <div className="flex flex-row nice-gap-1rem">
                                        <span className="text-30 text-nowrap text-capitalize">{trans("new:sales_advisor")}:</span>
                                        <span className="text-30  ">{lang == "ar" ? salesOrder?.FullNameAr : salesOrder?.FullNameEn}</span>
                                    </div>
                                    <div className="flex flex-row nice-gap-1rem">
                                        <span className="text-30 text-nowrap text-capitalize">{trans("new:mobile")}:</span>
                                        <span className="text-30 text-info-light " dir="ltr"><a className="text-30 text-info-light " href={"tel:" + salesOrder?.Phone}>{salesOrder?.Phone}</a></span>
                                    </div>
                                    <div className="flex flex-row nice-gap-1rem">
                                        <span className="text-30 text-nowrap text-capitalize">{trans("new:email")}:</span>
                                        <span className="text-30 text-info-light " dir="ltr"><a className="text-30 text-info-light " href={"mailto:" + salesOrder?.AuthorizedEmail}>{salesOrder?.AuthorizedEmail}</a></span>

                                    </div>

                                </div >

                                <div className="carOverview-page-body">
                                    <div className="panel-section panel-white">
                                        <div className={`panel-content  ${(indexPanel == "1000" & showPanel) ? "show-panel-info" : ""}`}>
                                            <div className="panel-content-top nice-container"

                                                onClick={(e) => showPanelInfo("1000")}

                                            >

                                                <h1 className="text-40 text-super-gray  text-capitalize"> {trans("new:guest_and_delegate_information")}</h1>

                                                <img src="/assets/icons/arrow.svg" />
                                            </div >

                                            <div className="panel-content-body">


                                                <div className="nice-container flex flex-col nice-gap-1rem p-10">


                                                    <div className="flex flex-row nice-gap-1rem ">
                                                        <div className="flex flex-col nice-gap-1rem ">
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:guest")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:mobile")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:phone_no")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:identity_or_iqama")}:</span>

                                                            {
                                                                orderCustInfo?.CR &&
                                                                <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:computer_number")}:</span>
                                                            }
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:nationality")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:address")}:</span>
                                                        </div>

                                                        <div className=" border-l mx-5"></div>
                                                        <div className="flex flex-col nice-gap-1rem">
                                                            <span className="text-30 height-5">{lang == "ar" ? orderCustInfo?.FullNameAr : orderCustInfo?.FullNameEn}</span>
                                                            <span className="text-30 height-5 " dir="ltr">{orderCustInfo?.Mobile}</span>
                                                            <span className="text-30 height-5 " dir="ltr">{orderCustInfo?.HomNo}</span>
                                                            <span className="text-30  height-5">{orderCustInfo?.Identity}</span>

                                                            {
                                                                orderCustInfo?.CR &&
                                                                <span className="text-30 height-5">{orderCustInfo?.CR}</span>
                                                            }

                                                            <span className="text-30  height-5">{lang == "ar" ? orderCustInfo?.NationalityAr : orderCustInfo?.NationalityEn}</span>
                                                            <span className="text-30 height-5">{orderCustInfo?.Address}</span>
                                                        </div>

                                                    </div>


                                                    {/* <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-30 text-bold text-nowrap">{" الضيف:"}</span>
                                                        <span className="text-30 ">{oerCustInfo?.FullNameAr}</span>
                                                    </div>
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-30 text-bold text-nowrap">{"رقم الجوال:"}</span>
                                                        <span className="text-30 ">{orderCustInfo?.Mobile}</span>
                                                    </div>rd
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-30 text-bold text-nowrap">{" رقم الهاتف:"}</span>
                                                        <span className="text-30 ">{orderCustInfo?.HomNo}</span>
                                                    </div>
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-30 text-bold text-nowrap">{"الهوية أو الإقامة:"}</span>
                                                        <span className="text-30  ">{orderCustInfo?.Identity}</span>
                                                    </div>
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-30 text-bold text-nowrap">{"رقم الحاسب الآلي:"}</span>
                                                        <span className="text-30 ">{"########"}</span>
                                                    </div>

                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-30 text-bold text-nowrap">{" الجنسية:"}</span>
                                                        <span className="text-30  ">{orderCustInfo?.NationalityAr}</span>
                                                    </div>
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-30 text-bold text-nowrap">{" العنوان:"}</span>
                                                        <span className="text-30 ">{orderCustInfo?.Address}</span>
                                                    </div> */}

                                                    <div className="border-line "></div>

                                                    <div className="flex flex-row nice-gap-1rem ">
                                                        <div className="flex flex-col nice-gap-1rem ">
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:authorized_person")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:authorization_type")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:mobile")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:identity_or_iqama")}:</span>
                                                            <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:nationality")}:</span>
                                                     

                                                        </div>
                                                        <div className=" border-l mx-5"></div>

                                                        <div className="flex flex-col nice-gap-1rem">
                                                            <span className="text-30 height-5">{orderAuthorized?.AuthorizedName}</span>
                                                            <div className="flex flex-row height-5">
                                                                <span className="text-30">{orderAuthorized?.AuthorizedToReceiveVehicle ? trans("new:vehicle_receipt") : ""}</span>
                                                                <span className="text-30 ">{(orderAuthorized?.AuthorizedToReceiveGTP && orderAuthorized?.AuthorizedToReceiveVehicle) ? " - " : ""}</span>
                                                                <span className="text-30 ">{orderAuthorized?.AuthorizedToReceiveGTP ? trans("new:customs_card") : ""}</span>
                                                            </div>
                                                            <span className="text-30 height-5 " dir="ltr">{orderAuthorized?.AuthorizedMobile}</span>
                                                            <span className="text-30  height-5">{orderAuthorized?.AuthorizedID}</span>
                                                            <span className="text-30  height-5">{lang == "ar" ? orderAuthorized?.NationalityAr : orderAuthorized?.NationalityEn}</span>

                                                        </div>


                                                    </div >

                                                    {
                                                        orderTrans?.VehicleUserName &&
                                                        <>

                                                            <div className="border-line "></div>
                                                            <div className="flex flex-row nice-gap-1rem ">
                                                                <div className="flex flex-col nice-gap-1rem ">
                                                                    {
                                                                        orderTrans?.VehicleUserName &&
                                                                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:VehicleUser")}:</span>
                                                                    }
                                                                    {
                                                                        orderTrans?.VehicleUserMobile &&
                                                                        <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:mobile")}:</span>
                                                                    }
                                                                    <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:identity_or_iqama")}:</span>
                                                                    <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:nationality")}:</span>

                                                                </div>
                                                                <div className=" border-l mx-5"></div>

                                                                <div className="flex flex-col nice-gap-1rem">

                                                                    {
                                                                        orderTrans?.VehicleUserName &&
                                                                        <span className="text-30  height-5">{orderTrans?.VehicleUserName}</span>
                                                                    }
                                                                    {
                                                                        orderTrans?.VehicleUserMobile &&
                                                                        <span className="text-30  height-5" dir="ltr">{orderTrans?.VehicleUserMobile}</span>
                                                                    }

                                                                    <span className="text-30  height-5">{orderTrans?.UserIDNo}</span>
                                                                    <span className="text-30  height-5">{lang == "ar" ? orderTrans?.nationaltyUserAr : orderTrans?.nationaltyUserEn}</span>

                                                                </div>


                                                            </div >
                                                        </>


                                                    }



                                                </div >
                                            </div >
                                        </div >
                                    </div >

                                    <div className="panel-section panel-white">
                                        <div className={`panel-content  ${(indexPanel == "2000" & showPanel) ? "show-panel-info" : ""}`}>
                                            <div className="panel-content-top nice-container"

                                                onClick={(e) => showPanelInfo("2000")}

                                            >
                                                <h1 className="text-40  text-super-gray text-capitalize"> {trans("new:vehicle_and_service_information")}</h1>

                                                <img src="/assets/icons/arrow.svg" />
                                            </div >

                                            <div className="panel-content-body  py-10">

                                                <div className="nice-container ">
                                                    <div className="flex flex-col nice-gap-1rem ">

                                                        <div className="flex flex-row nice-gap-1rem ">
                                                            <div className="flex flex-col nice-gap-1rem ">
                                                                <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:brand_and_type")}:</span>
                                                                <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:model")}:</span>
                                                                <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:color")}:</span>
                                                                <span className="text-30 text-bold text-nowrap height-5 text-capitalize">{trans("new:VIN")}:</span>
                                                                <span className="text-30 text-bold text-nowrap height-5 text-capitalize"  >{trans("new:item_code")}:</span>
                                                            </div>


                                                            <div className=" border-l mx-5"></div>
                                                            <div className="flex flex-col nice-gap-1rem">
                                                                <span className="text-30 height-5">{lang == "ar" ? (orderTrans?.BrandAr + " " + orderTrans?.GroupsAr) : (orderTrans?.BrandEn + " " + orderTrans?.GroupsEn)}</span>
                                                                <span className="text-30 height-5">{orderTrans?.Model}</span>
                                                                <span className="text-30 height-5">{lang == "ar" ? orderTrans?.ColorDescAr : orderTrans?.ColorDescEn}</span>
                                                                <span className="text-30  height-5">{orderTrans?.VIN}</span>
                                                                <span className="text-30 height-5">{orderTrans?.ProductNo}</span>

                                                            </div>

                                                        </div>

                                                        <div className="border-line text-gray-dark"></div>

                                                        <div className="flex flex-row nice-gap-1rem ">
                                                            <div className="flex flex-col nice-gap-1rem ">
                                                                <span className="text-30 text-bold text-nowrap  height-5 text-capitalize">{trans("new:plates_issuance")}:</span>
                                                                <span className="text-30 text-bold text-nowrap  height-5 text-capitalize">{trans("new:carwash")}:</span>
                                                            </div>

                                                            <div className=" border-l mx-5"></div>
                                                            <div className="flex flex-col nice-gap-1rem">
                                                                <span className="text-30  height-5 ">{orderTrans?.IssuePlatByUS ? trans("new:by") + " " + trans("mobileCommon:HJ-for-cars") : trans("new:by") + " " + trans("new:guest")}</span>
                                                                <span className="text-30  height-5">{orderTrans?.WithWashing ? trans("new:wash") : trans("new:without_wash")}</span>

                                                            </div>

                                                        </div>
                                                    </div >

                                                </div >




                                                <div className="panel-section panel-dark">
                                                    <div className={`panel-content   ${(indexPanelL2 == "1000" & showPanelL2) ? "show-panel-info" : ""}`}>
                                                        <div className="panel-content-top"

                                                            onClick={(e) => showPanelInfoL2("1000")}

                                                        >
                                                            <h1 className="text-40  text-super-gray font-bold text-capitalize">{trans("new:specifications")}</h1>

                                                            <img src="/assets/icons/arrow.svg" />
                                                        </div >

                                                        <div className="panel-content-body">

                                                            {
                                                                isLoadingVehicle ? (
                                                                    <>
                                                                        <div className="specs-section box-shadow-none">
                                                                            <div className="flex flex-wrap">
                                                                                <div className="specs-wrap-part">
                                                                                    <Skeleton count={1} borderRadius={"1rem"} width={"20rem"} height={"16rem"}
                                                                                        containerClassName={"my-5 "} className={"flex my-5 "} inline={true} />
                                                                                </div>
                                                                                <div className="specs-wrap-part">
                                                                                    <Skeleton count={1} borderRadius={"1rem"} width={"20rem"} height={"16rem"}
                                                                                        containerClassName={"my-5 "} className={"flex my-5 "} inline={true} />
                                                                                </div>
                                                                                <div className="specs-wrap-part">
                                                                                    <Skeleton count={1} borderRadius={"1rem"} width={"20rem"} height={"16rem"}
                                                                                        containerClassName={"my-5 "} className={"flex my-5 "} inline={true} />
                                                                                </div>
                                                                                <div className="specs-wrap-part">
                                                                                    <Skeleton count={1} borderRadius={"1rem"} width={"20rem"} height={"16rem"}
                                                                                        containerClassName={"my-5 "} className={"flex my-5 "} inline={true} />
                                                                                </div>
                                                                                <div className="specs-wrap-part">
                                                                                    <Skeleton count={1} borderRadius={"1rem"} width={"20rem"} height={"16rem"}
                                                                                        containerClassName={"my-5 "} className={"flex my-5 "} inline={true} />
                                                                                </div>
                                                                                <div className="specs-wrap-part">
                                                                                    <Skeleton count={1} borderRadius={"1rem"} width={"20rem"} height={"16rem"}
                                                                                        containerClassName={"my-5 "} className={"flex my-5 "} inline={true} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <Skeleton count={2} borderRadius={"2rem"} width={"100%"} height={"8rem"}
                                                                            containerClassName={"my-10"} className={"flex my-5 panel-content-top"} inline={false} />




                                                                    </>
                                                                ) : (

                                                                    <>
                                                                        <div className="specs-section box-shadow-none">
                                                                            <div className="specs-wrap">

                                                                                {
                                                                                    vehicleFeatures.map((feature, index) => {
                                                                                        return (
                                                                                            orderTrans &&
                                                                                            <div key={index} className="specs-wrap-part">
                                                                                                <div className="specs-wrap-part-titel">
                                                                                                    <span className="text-24 text-bold text-gray">{feature.title}</span>
                                                                                                    <img src="/assets/icons/calendar.svg" />
                                                                                                </div>
                                                                                                <div className="specs-wrap-part-contant text-24 text-gray text-bold">{orderTrans && orderTrans[feature.fieldName]}</div>

                                                                                            </div>
                                                                                        );
                                                                                    })
                                                                                }

                                                                            </div>
                                                                        </div>


                                                                        {
                                                                            extraDetails.map((details, index) => {
                                                                                return (
                                                                                    <div key={index} className="panel-section panel-white">
                                                                                        <div className={`panel-content  ${(indexPanelL3 == index & showPanelL3) ? "show-panel-info" : ""}`}>
                                                                                            <div className="panel-content-top"

                                                                                                onClick={(e) => showPanelInfoL3(index)}

                                                                                            >
                                                                                                <h1 className="text-30 text-bold  text-super-gray  font-bold text-capitalize">{lang == "ar" ? details?.sectionAr : details?.sectionEn}</h1>
                                                                                                <img src="/assets/icons/arrow.svg" />
                                                                                            </div>

                                                                                            <div className="panel-content-body">
                                                                                                <ul className="my-10">
                                                                                                    {
                                                                                                        details["note"].split('\n').map((note, index) => {
                                                                                                            return (

                                                                                                                note &&
                                                                                                                <li key={index} className="text-30 text-gray"  >
                                                                                                                    <span className="text-30 text-bold text-gray" >{note}</span>
                                                                                                                </li>
                                                                                                            );
                                                                                                        })
                                                                                                    }


                                                                                                </ul>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                );
                                                                            })


                                                                        }


                                                                    </>
                                                                )
                                                            }
                                                        </div>
                                                    </div >
                                                </div >


                                            </div >


                                        </div >
                                    </div >





                                    <div className="panel-section panel-white">
                                        <div className={`panel-content  ${(indexPanel == "5000" & showPanel) ? "show-panel-info" : ""}`}>
                                            <div className="panel-content-top nice-container"

                                                onClick={(e) => showPanelInfo("5000")}

                                            >
                                                <h1 className="text-40   text-super-gray text-capitalize"> {trans("new:center_information")}  </h1>

                                                <img src="/assets/icons/arrow.svg" />
                                            </div >

                                            <div className="panel-content-body">


                                                <div className="nice-container p-10 flex flex-row flex-wrap nice-gap-2rem">
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:service_provider")}</span>
                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:HJ_company")}</span>

                                                    </div >
                                                    <div className="border-l text-gray-dark my-3 mx-5"></div>
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:tax_number")}</span>
                                                        <span className="text-24 text-bold text-super-gray ">{"311073142900003"}</span>

                                                    </div >
                                                    {/* <div className="border-l text-gray-dark my-3 mx-5"></div> */}
                                                    < div className="flex flex-row nice-gap-1rem" >
                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:address")}</span>
                                                        <span className="text-24 text-bold text-super-gray  ">{trans("new:Dammam_KingFahd_suburb_car_showroom")}</span>

                                                    </div >
                                                    <div className="border-l text-gray-dark my-3 mx-5"></div>
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:commercial_record")}</span>
                                                        <span className="text-24 text-bold text-super-gray ">{"2050011700"}</span>

                                                    </div >
                                                    {/* <div className="border-l text-gray-dark my-3 mx-5"></div> */}
                                                    < div className="flex flex-row nice-gap-1rem" >
                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:postal_code")}:</span>
                                                        <span className="text-24 text-bold text-super-gray ">{"31441"}</span>

                                                    </div >
                                                    <div className="border-l text-gray-dark my-3 mx-5"></div>
                                                    <div className="flex flex-row nice-gap-1rem">
                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:mail_box")}:</span>
                                                        <span className="text-24 text-bold text-super-gray ">{"1666"}</span>

                                                    </div >
                                                    {/* <div className="border-l text-gray-dark my-3 mx-5"></div> */}
                                                    < div className="flex flex-row nice-gap-1rem" >

                                                        <span className="text-24 text-bold text-super-gray text-capitalize">{trans("new:contact_numbers")}:</span>
                                                        <div className="flex flex-row nice-gap-2rem">
                                                            <span className="text-24 text-bold text-info-light language-en border-line-b"><a className="text-24 text-bold text-info-light language-en " href={"tel:+966 13 820 5000"}>{"+966 13 820 5000 "}</a></span>
                                                            <span className="text-24 text-bold text-info-light language-en border-line-b"><a className="text-24 text-bold text-info-light language-en " href={"tel:+966 13 820 5000"}>{" +966 13 820 5000 "}</a></span>
                                                        </div>

                                                    </div >


                                                </div >
                                            </div >
                                        </div >
                                    </div >
                                </div >
                            </>
                            :

                            <div className="nice-container flex flex-col  text-center nice-gap-1rem">
                                <span className="text-24 text-info-light">{trans("new:not_created")}</span>
                            </div>

                    }





                </div >



            </section >


        </>



    )
};
export default SaleAgreement;